import { apiCall, axiosInstance, getConfig, serverUrl } from "./Utils";
import type { ApiResult } from "../types/api";

export interface BugReportPayload {
    /** Nature du signalement : "BUG" (défaut) ou "FEATURE" (demande de fonctionnalité) */
    kind?: "BUG" | "FEATURE";
    description: string;
    path: string;
    /** Base64 brut de la capture (sans le préfixe data:image/png;base64,) */
    screenshotBase64?: string;
    /** @deprecated legacy — utiliser screenshotBase64 */
    screenshotUrl?: string;
    username: string;
    pageStatus: string;
    details?: string;
    contactFirstName?: string;
    contactLastName?: string;
    contactEmail?: string;
}

/**
 * Envoie un rapport de bug au gateway, qui le relaie au manager-cms : le
 * signalement est archivé puis les admins abonnés sont notifiés (cloche in-app
 * + notification navigateur).
 * Endpoint : POST /notify/bug-report (public, aucune auth requise)
 */
async function sendBugReport(dto: BugReportPayload): Promise<ApiResult<void>> {
    return apiCall(
        axiosInstance.post(`${serverUrl}/api/notify/bug-report`, dto, getConfig())
    );
}

const ApiBugReportCtrl = {
    sendBugReport,
};

export default ApiBugReportCtrl;

